// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthMedia_root__wNHgz","media":"FullWidthMedia_media__uRjOM","content":"FullWidthMedia_content__Dytz6","mediaLink":"FullWidthMedia_mediaLink__skcxQ"};